// CreatePaymentGatewayCredentials.jsx
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { resetPaymentGatewayCredentialEditDataOnCreateFormData } from './redux/paymentGatewayCredentials.actions';
import { BreadCrumb, Timeline } from 'components';

import './createPaymentGatewayCredentials.scss';
import { onboardingProcessPG } from './constants';

const getDraftData = (draftData, sectionType) => {
    const filteredData =
        draftData &&
        draftData.length &&
        draftData.find(section => section.type === sectionType);
    return filteredData;
};

const CreatePaymentGatewayCredentials = ({
    isInEditMode = false,
    paymentGatewayCredentialsData,
    isViewMode = false,
    actions
}) => {
    const history = useHistory();

    const { draftData, createFormData } = paymentGatewayCredentialsData;
    console.log("draftData create Comp", paymentGatewayCredentialsData);

    const { location } = history;
    const onBoardSteps = onboardingProcessPG(draftData, location.pathname);

    const completedSection =
        onBoardSteps && onBoardSteps.filter(item => item.status === 'Complete');

    const lastSelected =
        completedSection.length &&
        completedSection[completedSection.length - 1];

    useEffect(() => {
        if (
            !location.pathname.includes(
                'payment-gateway-credentials/create/credentials'
            ) &&
            !createFormData.referenceId
        ) {
            history.push('/payment-gateway-credentials');
        }
    }, [createFormData]);


    useEffect(() => {
        actions.resetPaymentGatewayCredentialEditDataOnCreateFormData();
    }, []);

    return (
        <div
            className="create-pg-credentials-container"
            id="create-pg-credentials-container"
        >
            <div className="bread-crumbs">
                <h3>Create Payment Gateway Credentials</h3>
                <BreadCrumb
                    breadCrumbs={[
                        {
                            name: 'Payment Gateway Credentails',
                            link: '/payment-gateway-credentials',
                        },
                        {
                            name: 'Create Payment Gateway Credentails',
                            link: '',
                        },
                    ]}
                />
            </div>
            <div className="create-pg-credentials">
                <div className="left-section">
                    <Timeline
                        onboardingProcess={onBoardSteps}
                        isCreate={true}
                    />
                </div>
                <div className="right-section">
                    <Switch>
                        {onBoardSteps.map(tab => (
                            <Route exact path={tab.path} key={tab.tabId}>
                                {tab.component({
                                    ...tab,
                                    draftData: getDraftData(
                                        draftData,
                                        tab.sectionType
                                    ),
                                    onBoardSteps,
                                    isInEditMode,
                                    isViewMode,
                                    formIdentifier: createFormData.referenceId,
                                })}
                            </Route>
                        ))}
                    </Switch>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ loader, paymentGatewayCredentialsData }) => ({
    loader,
    paymentGatewayCredentialsData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        resetPaymentGatewayCredentialEditDataOnCreateFormData
    }, dispatch),
});

CreatePaymentGatewayCredentials.propTypes = {
    data: PropTypes.object.isRequired,
    actions: PropTypes.object,
    draftData: PropTypes.array,
    history: PropTypes.object,
    permissions: PropTypes.object,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreatePaymentGatewayCredentials);
